import { createSlice } from "@reduxjs/toolkit";
import { getDirectContact, getChannels, getMessages, addMessage, deleteMessage } from "./thunk";

const initialState = {
  chats: [],
  messages: [],
  channels: [],
  error: null,
};

const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDirectContact.fulfilled, (state, action) => {
        state.chats = action.payload;
      })
      .addCase(getDirectContact.rejected, (state, action) => {
        state.error = action.error.message;
      })
      .addCase(getChannels.fulfilled, (state, action) => {
        state.channels = action.payload;
      })
      .addCase(getChannels.rejected, (state, action) => {
        state.error = action.error.message;
      })
      .addCase(getMessages.fulfilled, (state, action) => {
        state.messages = action.payload;
      })
      .addCase(getMessages.rejected, (state, action) => {
        state.error = action.error.message;
      })
      .addCase(addMessage.fulfilled, (state, action) => {
        // Only add message if it has content
        if (action.payload && action.payload.content && action.payload.content.trim()) {
          state.messages.push(action.payload);
        }
      })
      .addCase(addMessage.rejected, (state, action) => {
        state.error = action.error.message;
      })
      .addCase(deleteMessage.fulfilled, (state, action) => {
        state.messages = state.messages.filter(
          (msg) => msg.id !== action.meta.arg
        );
      })
      .addCase(deleteMessage.rejected, (state, action) => {
        state.error = action.error.message;
      });
  },
});

export default chatSlice.reducer;
